import { StyleSheet } from 'aphrodite';
import theme from '~/src/theme';

export default StyleSheet.create({
  templatesPopulate: {
    marginBottom: theme.unit * 4,
  },
});
